<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    fullscreen
  >
    <div class="bg-white poppins position-relative min-h-100">
      <div
        class="modal-header py-3 px-4 px-sm-6 align-center bg-white position-sticky top-0 start-0 w-100 zindex-5 border-bottom shadow-xs"
      >
        <h4 class="mb-0 font-weight-bolder poppins text-truncate me-2">
          {{ detailTitle }}
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info flex-shrink-0"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div
        class="modal-body d-flex flex-column scroll-y mx-2 mx-sm-5 mx-xl-15 py-4 py-sm-7"
      >
        <!--begin::Body-->
        <div v-for="(item, i) in other" :key="i">
          <pop-up-selector
            ref="popup"
            :item="item"
            :id="id"
            :refresher="updateData"
            :toggleDetail="toggleModal"
            :deleteDocUrl="deleteDocUrl"
          />
        </div>
        <!--end::Body-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import PopUpSelector from "@/own/components/fulfillment/orders/popup/PopUpSelector.vue";

export default {
  name: "Others",
  props: ["updateDatatable"],
  components: { PopUpSelector },
  data: () => ({
    dialog: false,
    other: null,
    id: null,
    refresherFunction: null,
    deleteDocUrl: null,
    headerData: null,
  }),
  computed: {
    detailTitle() {
      if (this.deleteDocUrl?.includes("orders")) {
        return this.headerData
          ? this.$t("order_detail_with_reference", {
              reference: this.headerData,
            })
          : this.$t("order_detail");
      }
      return this.headerData
        ? this.$t("asn_detail_with_reference", {
            reference: this.headerData,
          })
        : this.$t("asn_detail");
    },
  },
  methods: {
    updateData(isEditable, isToggleable) {
      this.refresherFunction(this.id, isEditable, isToggleable);
      this.$refs.popup.forEach((popup) => {
        try {
          popup.fetchData();
        } catch {
          return;
        }
      });
    },
    setData(otherData, id, refresherFunction, deleteDocUrl, headerData = null) {
      this.other = otherData;
      this.id = id;
      this.refresherFunction = refresherFunction;
      this.deleteDocUrl = deleteDocUrl;
      this.headerData = headerData;
    },
    toggleModal() {
      if (this.dialog) {
        this.other = null;
        this.id = null;
        this.refresherFunction = null;
        this.updateDatatable();
        this.dialog = !this.dialog;
      } else {
        this.dialog = !this.dialog;
      }
    },
    // setData(otherData) {
    //   this.other = otherData;
    // },
    // toggleModal() {
    //   if (this.dialog) {
    //     this.other = null;
    //     this.dialog = !this.dialog;
    //   } else {
    //     this.dialog = !this.dialog;
    //   }
    // },
  },
};
</script>

<!--<style scoped>-->
<!--div {-->
<!--  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;-->
<!--  font-size: 15px;-->
<!--}-->
<!--</style>-->
